module.exports = __webpack_public_path__ + "img/icon_version.bc19fec4.png";